module.exports = "/img/hero-pattern.487b80d3.png";